import { HostListener, Directive,  ElementRef,  Input,  AfterViewInit } from '@angular/core';
import * as $ from "jquery";

@Directive({
  selector: '[scrollableModal]'
})
export class ScrollableModalDirective {

  constructor(private el: ElementRef) {
	this.resizeModalHeight()
  }
  
  ngAfterViewInit(): void {
	this.resizeModalHeight();
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
	this.resizeModalHeight();
  }
  
  resizeModalHeight(){
	setTimeout(()=>{
		let availableHeight = $(window).innerHeight() - $('.navbar-static-top').outerHeight() -60;
		if ($(window).innerWidth() <= 768) {
			availableHeight = availableHeight - 50;
		}
		//$('#masterAccount').find('.modal-body').css({'height': availableHeight, 'overflow-y': 'auto', 'overflow-x': 'hidden'});
	}, 500);
  }

}
